import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'constants/config';

import {
  loadCustomerCountByBranchesFail,
  loadCustomerCountByBranchesRequested,
  loadCustomerCountByBranchesSuccess,
  loadCustomerCountByRoundsRequested,
  loadCustomerCountByRoundsSuccess,
  loadCustomerCountByRoundsFail,
  loadPapersByRoundsRequested,
  loadPapersByRoundsSuccess,
  loadPapersByRoundsFail,
  loadPapersByRoundIdRequested,
  loadPapersByRoundIdFail,
  loadPapersByRoundIdSuccess,
  loadTotalCountSuccess,
  loadTotalCountFail,
  loadTotalCountRequested,
  loadBranchRoundsRequested,
  loadBranchRoundsSuccess,
  loadBranchRoundsFail,
  loadRoundPapersRequested,
  loadRoundPapersSuccess,
  loadRoundPapersFail,
} from './dashboardSlice';
import toast from 'react-hot-toast';

//load dashboard customer-count by branch
export function* loadCustomerCountByBranchesEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/dashboard/branches/customers-count`
    );

    if (data?.succeeded) {
      yield put(loadCustomerCountByBranchesSuccess(data));
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(loadCustomerCountByBranchesFail(error.message));
  }
}

//load dashboard customer-count by rounds
export function* loadCustomerCountByRoundsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/dashboard/rounds/customers-count`
    );

    if (data?.succeeded) {
      yield put(loadCustomerCountByRoundsSuccess(data));
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(loadCustomerCountByRoundsFail(error.message));
  }
}

//load dashboard papers by rounds
export function* loadPapersByRoundsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/dashboard/rounds/papers/${action?.payload?.date}?branchId=${
        action?.payload?.branch ?? ''
      }`
    );

    if (data?.succeeded) {
      yield put(loadPapersByRoundsSuccess(data));
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(loadPapersByRoundsFail(error.message));
  }
}

//load dashboard papers by round id
export function* loadPapersByRoundIdEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/dashboard/customers/papers/summary?id=${action?.payload?.id}&date=${action?.payload?.date}`
    );

    if (data?.succeeded) {
      yield put(loadPapersByRoundIdSuccess(data));
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(loadPapersByRoundIdFail(error.message));
  }
}

export function* loadTotalCountEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/dashboard/attributes/count`
    );

    if (data?.succeeded) {
      yield put(loadTotalCountSuccess(data));
    } else {
      toast.error(data?.errors);
    }
  } catch (error: any) {
    yield put(loadTotalCountFail(error.message));
  }
}

export function* loadBranchRoundsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/dashboard/rounds-by-branch${
        action?.payload ? `?branchId=${action.payload}` : ''
      }`
    );

    if (data?.succeeded) {
      yield put(loadBranchRoundsSuccess(data));
    }
  } catch (error: any) {
    yield put(loadBranchRoundsFail(error.message));
  }
}

export function* loadRoundPapersEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/dashboard/papers-count/${action?.payload?.roundId}/${action?.payload?.date}`
    );

    if (data?.succeeded) {
      yield put(loadRoundPapersSuccess(data));
    }
  } catch (error: any) {
    yield put(loadRoundPapersFail(error.message));
  }
}

export function* dashboardSaga(): Generator<any, void, any> {
  yield takeEvery(
    loadCustomerCountByBranchesRequested,
    loadCustomerCountByBranchesEffect
  );
  yield takeEvery(
    loadCustomerCountByRoundsRequested,
    loadCustomerCountByRoundsEffect
  );
  yield takeEvery(loadPapersByRoundsRequested, loadPapersByRoundsEffect);
  yield takeEvery(loadPapersByRoundIdRequested, loadPapersByRoundIdEffect);
  yield takeEvery(loadTotalCountRequested, loadTotalCountEffect);
  yield takeEvery(loadBranchRoundsRequested, loadBranchRoundsEffect);
  yield takeEvery(loadRoundPapersRequested, loadRoundPapersEffect);
}
